import React, { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface WrapperMobileProps {
    className?: string;
    children?: ReactNode;
}

const WrapperMobile = ({ className, children }: WrapperMobileProps) => {
    return (
        <section className={cn('w-full flex! pb-6  px-6  flex-col gap-6 max-w-full lg:max-w-[60%] md:max-w-[80%]  m-auto', className)}>
            {children}
        </section>
    )
}

export default WrapperMobile
